import apiClient from './_client';

export default {
    ageOptions() {
        return apiClient.get('options/age-ranges').then(response => {
            return response.ageRanges;
        });
    },
    countryLanguageOptions() {
        return apiClient.get('options/language-countries').then(response => {
            return response.languageCountries;
        });
    },
    predefinedTestersPanelOptions() {
        return apiClient.get('options/predefined-panels').then(response => {
            return response.predefinedPanels;
        });
    },
    testersPackagesOptions() {
        return apiClient.get('options/packages').then(response => {
            return response.packages;
        });
    },
    questions(testId) {
        return apiClient.get('options/questions/' + testId).then(response => {
            return response.questions;
        });
    },
    audienceRequirements() {
        return apiClient.get('options/audience-requirements').then(response => {
            return response.requirements;
        });
    },
    countParticipants(options) {
        return apiClient.post('options/count-participants', options).then(response => {
            return response.count;
        });
    }
}
